// extracted by mini-css-extract-plugin
module.exports = {"title":"SettungsInbox_title__2fGd8","alert":"SettungsInbox_alert__3-jAp"};